import React from "react";
//import React, { useEffect } from "react";

const WIND_LEVELS = ["10", "1000", "925", "850", "700", "500", "300", "250", "200"];

function HurricaneLegend({ show }) {
  if (!show) return null;

  const items = [
    { label: '< 34 kt', color: '#9e9e9e' },
    { label: '34–63 kt (TS)', color: '#3b82f6' },
    { label: '64–82 kt (Cat 1)', color: '#eab308' },
    { label: '83–95 kt (Cat 2)', color: '#f97316' },
    { label: '96–112 kt (Cat 3)', color: '#ef4444' },
    { label: '≥ 113 kt (Cat 4+)', color: '#7e22ce' },
  ];

  return (
    <div className="hurricane-note">
      <div className="legend-title">Storm Intensity</div>
      {items.map((item) => (
        <div key={item.label} className="legend-row">
          <span
            className="legend-color"
            style={{ backgroundColor: item.color }}
          />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}

function mapModel(selectedModel) {
  if (!selectedModel) return "";

  const map = {
    au_ifs: "EAUR",
    au_gfs: "NAUR",
    pw_ifs: "EPNG",
    pw_gfs: "NPNG",
    gc_ifs: "EGRP",
    gc_gfs: "NGRP",
    fcnv2_ifs: "EFOR",
    fcnv2_gfs: "NFOR",
    gfs_gfs: "GFS",
    ifs_ifs: "IFS",
    aifs_aifs: "AIFS",
  };

  return map[selectedModel] || "";
}

const WindControls = ({
    windState, setWindState,
    countyState, setCountyState,
    borderState, setBorderState,
    hurricaneState, setHurricaneState,
    hurricaneAvailable,
    hurricaneYear, setHurricaneYear, 
    hurricaneCycle, setHurricaneCycle,
    availableHurricaneYears,
    availableHurricaneCycles,
    hurricaneModelAvailable,
    selectedDeckModel,
    hurricaneTrackMode,
    setHurricaneTrackMode,
    hurricaneRadii34State,
    setHurricaneRadii34State,
    hasWindRadii34,
    //hurricaneModelMode,
    //setHurricaneModelMode,
    selectedStormIds,
    setSelectedStormIds,
    selectedModelStorms = [],
    allModelStorms = [],
    singleMapRef,
    griddedMapRefs,
    compareBool,
    gridModels,
    sliderPresLev, setSliderPresLev
}) => {
    const currentIdx = WIND_LEVELS.indexOf(sliderPresLev);

    const handleWindLevelChange = (e) => {
        const idx = parseInt(e.target.value, 10);
        setSliderPresLev(WIND_LEVELS[idx]);
    };
    
    const supportedHurricaneModels = compareBool
      ? gridModels.filter((model, index) => hurricaneModelAvailable?.[index])
      : hurricaneModelAvailable
        ? [selectedDeckModel]
        : [];

    const hasSelectedHurricaneModels = supportedHurricaneModels.length > 0;

    const selectedModelLabel = compareBool
      ? supportedHurricaneModels.map((m) => mapModel(m)).join(", ")
      : selectedDeckModel;
   
    /*const getAvailableStorms = (rows = []) => {
      const stormMap = new Map();

      rows.forEach((row) => {
        if (!row.storm_id) return;

        stormMap.set(row.storm_id, {
          storm_id: row.storm_id,
          storm_name: row.storm_name || "Invest",
        });
      });

      return Array.from(stormMap.values());
    };*/

    //const selectedModelRows = hurricaneRows.filter(
    //  (row) => row.model === selectedDeckModel
    //);

    //const selectedModelStorms = getAvailableStorms(selectedModelRows);
    //const allModelStorms = getAvailableStorms(hurricaneRows);

    //const visibleStorms =
    //  hurricaneModelMode === "selected"
    //    ? selectedModelStorms
    //    : allModelStorms;

    //const toggleStorm = (stormId) => {
    //  setSelectedStormIds((prev = []) =>
    //    prev.includes(stormId)
    //      ? prev.filter((id) => id !== stormId)
    //      : [...prev, stormId]
     // );
    //};

    /*const selectedModelStorms = Array.from(
      new Map(
        (hurricaneRows || [])
          .filter((row) => row.model === selectedModelLabel)
          .map((row) => [
           row.storm_id,
          {
            storm_id: row.storm_id,
            storm_name: row.storm_name || row.name || "Invest",
          },
        ])
      ).values()
    );

    const allModelStorms = Array.from(
      new Map(
        (hurricaneRows || []).map((row) => [
          row.storm_id,
          {
            storm_id: row.storm_id,
            storm_name: row.storm_name || row.name || "Invest",
          },
        ])
      ).values()
    );
    
    useEffect(() => {
      const stormIds =
        hurricaneTrackMode === "selected"
          ? selectedModelStorms.map((s) => s.storm_id)
          : allModelStorms.map((s) => s.storm_id);

      setSelectedStormIds(stormIds);
    }, [hurricaneTrackMode, hurricaneRows, selectedModelLabel]); 
    */
    return (
        <div className="sidebar-section">
            <div className="sidebar-section-title">Overlays</div>
            <div className="overlay-toggles">
                <label className="overlay-toggle">
                    <input type="checkbox" checked={borderState} onChange={() => setBorderState(!borderState)} />
                    <span>Contour Lines</span>
                </label>
                <label className="overlay-toggle">
                    <input type="checkbox" checked={countyState} onChange={() => setCountyState(!countyState)} />
                    <span>Counties</span>
                </label>
                {/*<label className="overlay-toggle">
                  <input
                    type="checkbox"
                    checked={hurricaneState}
                    onChange={() => setHurricaneState(!hurricaneState)}
                    />
                    <span>Storm Track(s)</span>
                </label>*/}
                <label className="overlay-toggle">
                  <input
                    type="checkbox"
                    checked={hurricaneState}
                    /*onChange={() => {
                      const newState = !hurricaneState;
                      setHurricaneState(newState);

                      // Hurricane tracks turned OFF
                      if (!newState) {

                        // Reset single map
                        if (singleMapRef?.current) {
                          singleMapRef.current.flyTo({
                            center: [-90, 40],
                            zoom: 3,
                            duration: 1500
                          });
                        }

                        // Reset gridded maps
                        if (griddedMapRefs?.current) {
                          griddedMapRefs.current.forEach((map) => {
                            if (map) {
                              map.flyTo({
                                center: [-95, 40],
                                zoom: 2,
                                duration: 1500
                              });
                            }
                          });
                        }
                      }
                    }}*/
                    /*onChange={() => {
                      const newState = !hurricaneState;
                      setHurricaneState(newState);

                      // Storm tracks turned ON
                      if (newState) {
                        const globalView = {
                          center: [0, 20],
                          zoom: 1,
                          duration: 1500,
                        };

                        if (singleMapRef?.current) {
                          singleMapRef.current.flyTo(globalView);
                        }

                        if (griddedMapRefs?.current) {
                          griddedMapRefs.current.forEach((map) => {
                            map?.flyTo(globalView);
                          });
                        }
                      }

                      // Optional: Storm tracks turned OFF
                      if (!newState) {
                        if (singleMapRef?.current) {
                          singleMapRef.current.flyTo({
                            center: [-90, 40],
                            zoom: 3,
                            duration: 1500,
                          });
                        }

                        if (griddedMapRefs?.current) {
                          griddedMapRefs.current.forEach((map) => {
                            map?.flyTo({
                              center: [-95, 40],
                              zoom: 2,
                              duration: 1500,
                            });
                          });
                        }
                      }
                    }}
                  />
                  <span>Storm Track(s)</span>
                </label>
                */
                    onChange={() => {
                      const newState = !hurricaneState;
                      setHurricaneState(newState);

                      const hasStormTracks =
                        hurricaneTrackMode === "all"
                          ? allModelStorms.length > 0
                          : selectedModelStorms.length > 0;

                      if (newState && hasStormTracks) {
                        const globalView = {
                          center: [0, 20],
                          zoom: 1,
                          duration: 1500,
                        };

                        singleMapRef?.current?.flyTo(globalView);

                        griddedMapRefs?.current?.forEach((map) => {
                          map?.flyTo(globalView);
                        });
                      }

                      if (!newState) {
                        singleMapRef?.current?.flyTo({
                          center: [-90, 40],
                          zoom: 3,
                          duration: 1500,
                        });

                        griddedMapRefs?.current?.forEach((map) => {
                          map?.flyTo({
                            center: [-95, 40],
                            zoom: 2,
                            duration: 1500,
                          });
                        });
                      }
                    }}
                  />
                  <span>Storm Track(s)</span>
                </label>            
 
                {/*{hurricaneState && (
                  <>
                    <label className="overlay-toggle nested">
                      <input
                        type="radio"
                        name="hurricaneModelMode"
                        checked={hurricaneModelMode === "selected"}
                        onChange={() => {
                          setHurricaneModelMode("selected");
                          setSelectedStormIds(selectedModelStorms.map((s) => s.storm_id));
                        }}
                      />
                      <span>Selected model only ({selectedDeckModel})</span>
                    </label>

                    {hurricaneModelMode === "selected" && (
                      <div className="storm-checkbox-list">
                        {visibleStorms.map((storm) => (
                          <label key={storm.storm_id} className="overlay-toggle nested">
                            <input
                              type="checkbox"
                              checked={selectedStormIds.includes(storm.storm_id)}
                              onChange={() => toggleStorm(storm.storm_id)}
                            />
                            <span>{storm.storm_name} ({storm.storm_id})</span>
                          </label>
                        ))}
                      </div>
                    )}

                    <label className="overlay-toggle nested">
                      <input
                        type="radio"
                        name="hurricaneModelMode"
                        checked={hurricaneModelMode === "all"}
                        onChange={() => {
                          setHurricaneModelMode("all");
                          setSelectedStormIds(allModelStorms.map((s) => s.storm_id));
                        }}
                      />
                      <span>All model tracks</span>
                    </label>

                    {hurricaneModelMode === "all" && (
                      <div className="storm-checkbox-list">
                        {visibleStorms.map((storm) => (
                          <label key={storm.storm_id} className="overlay-toggle nested">
                            <input
                              type="checkbox"
                              checked={selectedStormIds.includes(storm.storm_id)}
                              onChange={() => toggleStorm(storm.storm_id)}
                            />
                            <span>{storm.storm_name} ({storm.storm_id})</span>
                          </label>
                        ))}
                      </div>
                    )}
                  </>
                )}*/}   
             
                {/*{hurricaneState && hurricaneAvailable && hasSelectedHurricaneModels && */}
                {hurricaneState &&
                  hurricaneAvailable &&
                  (selectedModelStorms.length > 0 || allModelStorms.length > 0) && (
                  <div className="hurricane-track-mode">
                    <label className="overlay-toggle">
                      <input
                        type="radio"
                        name="hurricaneTrackMode"
                        value="selected"
                        checked={hurricaneTrackMode === 'selected'}
                        onChange={() => {
                          setHurricaneTrackMode("selected");
                          setSelectedStormIds(selectedModelStorms.map((s) => String(s.storm_id)));
                          //setSelectedStormIds(selectedModelStorms.map((s) => s.storm_id));
                        }}
                      />
                      <span>Selected model only ({selectedModelLabel})</span>
                    </label>
                   
                    {hurricaneTrackMode === "selected" &&
                      selectedModelStorms.map((storm) => (
                        <label key={`selected-${storm.storm_id}`} className="overlay-toggle hurricane-storm-checkbox">
                          <input
                            type="checkbox"
                            //checked={selectedStormIds?.includes(storm.storm_id)}
                            checked={(selectedStormIds || []).map(String).includes(String(storm.storm_id))}
                            onChange={(e) => {
                              const id = String(storm.storm_id);

                              setSelectedStormIds((prev = []) =>
                                e.target.checked
                                  ? [...new Set([...prev.map(String), id])]
                                  : prev.map(String).filter((stormId) => stormId !== id)
                              );
                            }}
                            //onChange={(e) => {
                            //  setSelectedStormIds((prev = []) =>
                             //   e.target.checked
                             //     ? [...new Set([...prev, storm.storm_id])]
                             //     : prev.filter((id) => id !== storm.storm_id)
                             //   );
                             // }}
                            />
                            <span>{storm.storm_name} ({storm.storm_id})</span>
                          </label>
                    ))} 
                    {/* added 61826 */ }
                    {/*{hurricaneTrackMode === "selected" &&
                      selectedModelStorms?.map((storm) => (
                        <label
                          key={`selected-${storm.storm_id}`}
                          className="overlay-toggle hurricane-storm-checkbox"
                        >
                          <input
                            type="checkbox"
                            checked={selectedStormIds?.includes(storm.storm_id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedStormIds((prev = []) => [
                                  ...new Set([...prev, storm.storm_id]),
                                ]);

                                zoomToStormBounds?.(storm.storm_id);
                              } else {
                                setSelectedStormIds((prev = []) =>
                                  prev.filter((id) => id !== storm.storm_id)
                                );
                              }
                            }}
                          />

                          <span>
                            {storm.storm_name || storm.name || "Invest"} ({storm.storm_id})
                          </span>
                        </label>
                    ))}*/}
                    {/* added 6/15/26 */ }
                    {/*{hurricaneTrackMode === "selected" && (
                      <div className="storm-checkbox-list">
                        {selectedModelStorms.map((storm) => (
                          <label key={storm.storm_id} className="overlay-toggle nested">
                            <input
                              type="checkbox"
                              checked={selectedStormIds.includes(storm.storm_id)}
                              onChange={() => toggleStorm(storm.storm_id)}
                            />
                            <span>{storm.storm_name} ({storm.storm_id})</span>
                          </label>
                        ))}
                      </div>
                    )}*/}
                    <label className="overlay-toggle">
                      <input
                        type="radio"
                        name="hurricaneTrackMode"
                        value="all"
                        checked={hurricaneTrackMode === 'all'}
                        onChange={() => {
                          setHurricaneTrackMode("all");
                          setSelectedStormIds(allModelStorms.map((s) => String(s.storm_id)));
                          //setSelectedStormIds(allModelStorms.map((s) => s.storm_id));
                        }}
                      />
                      <span>All model tracks</span>
                    </label>
                    {hurricaneTrackMode === "all" &&
                      allModelStorms.map((storm) => (
                        <label key={`all-${storm.storm_id}`} className="overlay-toggle hurricane-storm-checkbox">
                          <input
                            type="checkbox"
                            checked={(selectedStormIds || []).map(String).includes(String(storm.storm_id))}
                            //checked={selectedStormIds?.includes(storm.storm_id)}
                            onChange={(e) => {
                              const id = String(storm.storm_id);

                              setSelectedStormIds((prev = []) =>
                                e.target.checked
                                  ? [...new Set([...prev.map(String), id])]
                                  : prev.map(String).filter((stormId) => stormId !== id)
                                );
                              }}
                            //onChange={(e) => {
                            //  setSelectedStormIds((prev = []) =>
                            //    e.target.checked
                            //      ? [...new Set([...prev, storm.storm_id])]
                            //      : prev.filter((id) => id !== storm.storm_id)
                            //  );
                            //}}
                          />
                          <span>{storm.storm_name} ({storm.storm_id})</span>
                        </label>
                    ))} 
                    {/*added on 61826*/}
                    {/*{hurricaneTrackMode === "all" &&
                      allModelStorms?.map((storm) => (
                        <label
                          key={`all-${storm.storm_id}`}
                          className="overlay-toggle hurricane-storm-checkbox"
                        >
                          <input
                            type="checkbox"
                            checked={selectedStormIds?.includes(storm.storm_id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedStormIds((prev = []) => [
                                  ...new Set([...prev, storm.storm_id]),
                                ]);

                                zoomToStormBounds?.(storm.storm_id);
                              } else {
                                setSelectedStormIds((prev = []) =>
                                  prev.filter((id) => id !== storm.storm_id)
                                );
                              }
                            }}
                          />

                          <span>
                            {storm.storm_name || storm.name || "Invest"} ({storm.storm_id})
                          </span>
                        </label>
                    ))}*/}
                      
                    {/*{hurricaneTrackMode === "all" && (
                      <div className="storm-checkbox-list">
                        {allModelStorms.map((storm) => (
                          <label key={storm.storm_id} className="overlay-toggle nested">
                            <input
                              type="checkbox"
                              checked={selectedStormIds.includes(storm.storm_id)}
                              onChange={() => toggleStorm(storm.storm_id)}
                            />
                            <span>{storm.storm_name} ({storm.storm_id})</span>
                          </label>
                        ))}
                      </div>
                    )}*/}
                  </div>
                )}
                {/*<label className="overlay-toggle">
                    <input type="checkbox" checked={hurricaneState} onChange={() => setHurricaneState(!hurricaneState)} />
                    <span>Hurricane Tracks</span>
                </label>*/
                /*<label className="overlay-toggle">
                    <input type="checkbox" checked={windState} onChange={() => setWindState(!windState)} />
                    <span>Wind Barbs</span>
                </label>*/
                /*<label className="overlay-toggle">
                    <input type="checkbox" checked={hurricaneState} onChange={() => setHurricaneState(!hurricaneState)} />
                    <span>Hurricane Tracks</span>
                </label>*/}
                {hurricaneState && hurricaneAvailable && hurricaneYear === "2026" && hurricaneCycle === "042000" && (
                  <div className="hurricane-note hurricane-note-test">
                    <span className="hurricane-note-icon">🌪️ </span>
                    <span className="hurricane-note-text">
                      Displaying static storm track data (2026/042000).
                    </span>
                  </div>
                )}
                {hurricaneState && !hurricaneAvailable && (
                  <div className="hurricane-note">
                    <span className="hurricane-note-icon">⚠️  </span>
                    <span className="hurricane-note-text">
                      No data available at the selected initialization time.
                    </span>
                  </div>
                )}
                {/*{hurricaneState && hurricaneAvailable && hurricaneTrackMode === 'selected' && !hasSelectedHurricaneModels && (
                  <div className="hurricane-note">
                    <span className="hurricane-note-icon">⚠️  </span>
                    <span className="hurricane-note-text">
                      {compareBool
                        ? "No storm tracks available for any selected comparison models."
                        : `No storm tracks available for selected model ${selectedDeckModel}.`}
                    </span>
                  </div>
                )}*/}
                {/*hurricaneTrackMode === "selected" &&
                  selectedModelStorms.length === 0 && (*/}
                {/*{hurricaneState &&
                  hurricaneAvailable &&
                  allModelStorms.length === 0 && (
                    <div className="hurricane-note">
                      <span className="hurricane-note-icon">⚠️ </span>
                      <span className="hurricane-note-text">
                        {compareBool
                          ? "No storm tracks available for any selected comparison models."
                          : `No storm tracks available for selected model ${selectedDeckModel}.`}
                      </span>
                    </div>
                )}*/}
                {hurricaneState &&
                  hurricaneTrackMode === "selected" &&
                  selectedModelStorms.length === 0 && (
                  <div className="hurricane-warning">
                    ⚠️  Current selected model ({selectedModelLabel}) is not available for storm tracks.
                  </div>
                )} 

                {hurricaneState &&
                  hurricaneTrackMode === "all" &&
                  allModelStorms.length === 0 && (
                    <div className="hurricane-warning">
                      ⚠️  No storm tracks available for all models.
                    </div>
                )}
    
                {hurricaneState && (
                  <label className="overlay-toggle sub-toggle">
                  <input
                    type="checkbox"
                    checked={hurricaneRadii34State}
                    disabled={!hasWindRadii34}
                    onChange={() => setHurricaneRadii34State(!hurricaneRadii34State)}
                  />
                  <span>34 kt Wind Radii {!hasWindRadii34 ? '(not available)' : '(when available)'}</span>
                  </label>
                )}  

                <HurricaneLegend show={hurricaneState} />
                {/* 👇 SHOW CONTROLS WHEN CHECKED */}
                {/*{hurricaneState && hurricaneAvailable && (
                  <div className="hurricane-controls">
                    <div className="hurricane-control-group">
                      <label>Year</label>
                      <select
                        value={hurricaneYear}
                        onChange={(e) => setHurricaneYear(e.target.value)}
                      >
                        {availableHurricaneYears.map((y) => (
                          <option key={y} value={y}>{y}</option>
                        ))}
                      </select>
                    </div>

                    <div className="hurricane-control-group">
                      <label>Cycle</label>
                      <select
                        value={hurricaneCycle}
                        onChange={(e) => setHurricaneCycle(e.target.value)}
                      >
                        {availableHurricaneCycles.map((c) => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}*/}
                <label className="overlay-toggle">
                    <input type="checkbox" checked={windState} onChange={() => setWindState(!windState)} />
                    <span>Wind Barbs</span>
                </label>
            </div>

            {windState && (
                <div className="level-control" style={{ marginTop: 10 }}>
                    <div className="level-display">{currentIdx === 0 ? "10 m" : `${WIND_LEVELS[currentIdx]} hPa`}</div>
                    <input
                        type="range"
                        className="level-slider"
                        min={0}
                        max={WIND_LEVELS.length - 1}
                        value={currentIdx >= 0 ? currentIdx : 0}
                        onChange={handleWindLevelChange}
                    />
                    <div className="level-labels">
                        <span>Sfc</span>
                        <span>200 hPa</span>
                    </div>
                </div>
            )}

            {/* Hidden elements for jQuery slider init (legacy) */}
            <div id="levelslider" style={{ display: 'none' }}></div>
            <div id="levelsliderlabels" style={{ display: 'none' }}></div>
        </div>
    );
};

export default WindControls;
